import {Settings} from '../../settings';

export const getStoredData = () => {
  return JSON.parse(localStorage.getItem(Settings.groupDomain));
};

export const storeData = (property, value) => {
  var currentData = JSON.parse(localStorage.getItem(Settings.groupDomain));
  if (!currentData) currentData = {};
  if (property) currentData[property] = value;
  return localStorage.setItem(Settings.groupDomain, JSON.stringify(currentData));
};

export const removeStoredData = (property) => {
  const currentData = JSON.parse(localStorage.getItem(Settings.groupDomain));
  if (property) delete currentData[property];
  return localStorage.setItem(Settings.groupDomain, JSON.stringify(currentData));
  // return localStorage.removeItem(Settings.groupDomain);
};
